import Vue from "vue";
import VueRouter from "vue-router";

import Bygninger from "../views/Bygninger.vue";
import Home from "../views/Home.vue";
import Projekter from "../views/Projekter.vue";
import Restaureringer from "../views/Restaureringer.vue";
import Kirker from "../views/Kirker.vue";
import Cv from "../views/Cv.vue";
import Tegninger from "../views/Tegninger.vue";
import Malerier from "../views/Malerier.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "",
    component: Home
  },
  {
    path: "/bygninger",
    component: Bygninger
  },
  {
    path: "/projekter",
    component: Projekter
  },
  {
    path: "/restaureringer",
    component: Restaureringer
  },
  {
    path: "/kirker",
    component: Kirker
  },
  {
    path: "/malerier",
    component: Malerier
  },
  {
    path: "/tegninger",
    component: Tegninger
  },
  {
    path: "/cv",
    component: Cv
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  linkActiveClass: "active",
  routes
});

export default router;
